import React, { useMemo } from "react";
import Chart from "react-apexcharts";
import { withNamespaces } from "react-i18next";
import { Card, CardBody, CardTitle, UncontrolledTooltip } from "reactstrap";

const LinkingDonut = ({ t, id, label, helpText, matched, unmatched }) => {
    const options = useMemo(() => ({
        chart: {
            type: "donut",
            toolbar: { show: false }
        },
        labels: [t("Matched"), t("Unmatched")],
        colors: ["#198754", "#dc3545"],
        plotOptions: {
            pie: {
                donut: {
                    size: "65%",
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: t("Linked"),
                            formatter: () => `${matched}%`
                        }
                    }
                }
            }
        },
        dataLabels: { enabled: false },
        legend: { position: "bottom" },
        tooltip: {
            y: { formatter: (val) => `${val}%` }
        }
    }), [ matched , t]);

    return (
        <Card className="h-100">
            <CardBody>
                <CardTitle tag="h6">
                    <span className="me-1">
                        {t(label)}
                    </span>
                    <i
                        className="ri-information-line"
                        style={{
                            cursor: 'pointer'
                        }}
                        id={id}
                    />

                    <UncontrolledTooltip
                        target={id}
                    >
                        {t(helpText)}
                    </UncontrolledTooltip>
                </CardTitle>
                <Chart 
                    options={options} 
                    series={[matched, unmatched]} 
                    type="donut" 
                    height={280} 
                />
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    LinkingDonut
);
